import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import Dialog from 'app/components/Dialog';
import TagPicker from 'app/components/TagPicker';
import { Button } from 'app/components/Mui';

type Props = {
  open: boolean;
  onClose: (tag?:string | null) => void;
  initialTag?: string;
  title?: string;
};

const TagPickerDialog = ({
  // Props
  open, onClose, initialTag, title
}:Props) => {
  const { t } = useTranslation();

  const [ tag, setTag ] = useState<string | null>(initialTag || null);

  const handleClick = (newTag:string | null) => {
    setTag(tag === newTag ? null : newTag);
  }

  const handleCloseClick = (withTag:boolean = false) => () => {
    onClose(withTag ? tag : undefined);
  }

  const isLoading = false;

  const actions = (
    <Fragment>
      <Button
        name="Cancel page tag dialog"
        onClick={handleCloseClick()}
      >{t('buttons.close')}</Button>
      <Button
        name="Save page tag dialog"
        onClick={handleCloseClick(true)}
        loading={isLoading}
        variant="contained"
        color="primary"
      >{t('buttons.save')}</Button>
    </Fragment>
  );
  return (
    <Dialog
      open={open}
      onClose={handleCloseClick()}
      maxWidth="sm"
      title={title || t('dialogs.cardPageTags.title')}
      actions={actions}
    >
      <TagPicker
        id="cardPageTagDialog"
        activeTags={[tag]}
        onClick={handleClick}
      />
    </Dialog>
  )
}

export default TagPickerDialog;